export const SEARCH_QUERIES = [
  // Hot intent
  { label: '"token launch" lang:en', category: 'hot' },
  { label: '"NFT mint" today', category: 'hot' },
  { label: '"airdrop" "KOL" -scam', category: 'hot' },
  { label: '"TGE" "2026"', category: 'hot' },
  { label: '"token launch" "marketing"', category: 'hot' },
  { label: '"going live" crypto 2026', category: 'hot' },
  { label: '"presale" "open" crypto', category: 'hot' },
  { label: '"mainnet" launch announcement', category: 'hot' },

  // Hiring signals
  { label: '"hiring" "community manager" web3', category: 'hiring' },
  { label: '"looking for" "social media" crypto', category: 'hiring' },
  { label: '"marketing lead" defi 2026', category: 'hiring' },
  { label: '"growth" "marketing" "web3" -job', category: 'hiring' },
  { label: '"we need" "KOL manager" crypto', category: 'hiring' },
  { label: '"hiring" "growth marketer" web3', category: 'hiring' },
  { label: '"looking for" "content writer" NFT', category: 'hiring' },
  { label: '"need a" "community manager" discord', category: 'hiring' },
  { label: '"hiring" "brand ambassador" crypto', category: 'hiring' },
  { label: '"part time" "social media" web3', category: 'hiring' },
  { label: '"freelance" "web3 marketer" needed', category: 'hiring' },
  { label: '"remote" "crypto marketing" role', category: 'hiring' },

  // Launch signals
  { label: '"pre-sale" launch announcement', category: 'launch' },
  { label: '"whitelist" "mint" open', category: 'launch' },
  { label: '"public sale" opening soon', category: 'launch' },
  { label: '"IDO" launching crypto', category: 'launch' },
  { label: '"stealth launch" crypto', category: 'launch' },
  { label: '"fair launch" defi', category: 'launch' },
  { label: '"seed round" closed crypto 2026', category: 'launch' },
  { label: '"beta launch" web3 app', category: 'launch' },

  // Collab signals
  { label: '"collab" "partnership" web3 marketing', category: 'collab' },
  { label: '"KOL" "ambassador" program open', category: 'collab' },
  { label: '"looking for" "partners" NFT project', category: 'collab' },
  { label: '"open to" "collabs" crypto', category: 'collab' },
  { label: '"ambassador" "apply" web3', category: 'collab' },
  { label: '"affiliate" "program" crypto launch', category: 'collab' },
  { label: '"referral" "program" defi', category: 'collab' },
];

export const GREEN_FLAGS = [
  { title: 'Tweeting daily or had a tweet today', tip: 'Active projects have marketing budget burning' },
  { title: 'Has a website + whitepaper linked in bio', tip: 'Real project, not a rug' },
  { title: 'Token not launched yet (pre-TGE)', tip: 'They NEED marketing most right now' },
  { title: '500+ followers, real engagement', tip: 'Comments from real accounts, not just bots' },
  { title: 'Doxxed team or LinkedIn-linked founders', tip: 'Reduces rug risk significantly' },
];

export const RED_FLAGS = [
  { title: 'No website, anonymous team only', tip: 'High rug risk — skip unless they pay upfront' },
  { title: '"Pay in our token" only', tip: 'Worthless until listed. Demand at least partial USDT' },
  { title: 'Asks you to invest or buy first', tip: 'This is a scam. Block immediately.' },
  { title: 'Account created this week, no history', tip: 'Likely fake or rug. Move on fast.' },
  { title: 'No replies/engagement despite big following', tip: 'Bought followers. Project is dead.' },
];

export const PITCH_SCRIPTS = [
  // ── CONTENT WRITING ──
  {
    id: 'threads',
    category: 'content',
    label: 'Thread Writing — Quick offer',
    badge: 'Best for pre-launch',
    badgeColor: 'accent',
    template: `Hey [name] 👋

Saw your [project name] launch — the concept is solid.

I'm Ade, a Web3 content writer. I can write you 5 ready-to-post Twitter threads designed to build hype before your TGE/mint.

Cost: $50 USDT. Delivered in 2 hours. No fluff.

Want to see a sample first?`,
  },
  {
    id: 'trial',
    category: 'content',
    label: 'Thread Writing — Free trial (easiest yes)',
    badge: 'Most replies',
    badgeColor: 'blue',
    template: `Hey — quick one.

I'll write you 2 Twitter threads about [project name] for free right now, just to show you what I can do.

If you like them, I'll do 10 more for $80 USDT. If not, keep the free ones, no hard feelings.

Interested?`,
  },
  {
    id: 'content-calendar',
    category: 'content',
    label: 'Content Calendar — Monthly package',
    badge: 'Recurring income',
    badgeColor: 'accent',
    template: `Hi [name],

I help Web3 projects stay consistent on social — full content calendars, daily posts, launch threads, and community updates.

For [project name], I can put together a 30-day content calendar for $150 USDT/month. Covers Twitter, Discord announcements, and Telegram updates.

Want me to send a sample week plan so you can see the format?`,
  },

  // ── KOL MANAGEMENT ──
  {
    id: 'kol-intro',
    category: 'kol',
    label: 'KOL Management — Intro pitch',
    badge: 'High value',
    badgeColor: 'amber',
    template: `Hey [name],

I'm Ade — I manage KOL campaigns for Web3 projects. I handle sourcing, outreach, briefing, and performance tracking so your team doesn't have to.

For [project name]'s upcoming launch, I can put together a KOL seeding campaign — 10–20 micro/mid KOLs in your niche, coordinated posts timed around your TGE.

Price: $200–$500 USDT depending on scope.

Worth a quick chat?`,
  },
  {
    id: 'kol-trial',
    category: 'kol',
    label: 'KOL Management — Small trial campaign',
    badge: 'Low barrier',
    badgeColor: 'blue',
    template: `Hi [name],

I noticed [project name] hasn't done much KOL outreach yet — that's actually a big opportunity before launch.

I can run a small trial KOL campaign for you — 5 targeted influencers in the [niche] space, briefed and posted within 48 hours.

Trial price: $100 USDT. If results are good, we scale up.

Interested?`,
  },
  {
    id: 'kol-existing',
    category: 'kol',
    label: 'KOL Management — Improve existing program',
    badge: 'For active projects',
    badgeColor: 'amber',
    template: `Hey [name],

Saw that [project name] already has some KOL activity going — nice. But from the outside, it looks like the coordination and timing could be tighter.

I specialize in KOL campaign management — briefing, scheduling, follow-up, and tracking reach/engagement. I can plug into what you already have and make it perform better.

Open to a quick call to see if it's a fit?`,
  },

  // ── SOCIAL MEDIA MANAGEMENT ──
  {
    id: 'smm-full',
    category: 'social',
    label: 'Social Media Management — Full package',
    badge: 'Retainer gig',
    badgeColor: 'accent',
    template: `Hi [name],

I'm Ade, a Web3 social media manager. I handle full Twitter/X management for crypto projects — daily posts, community replies, thread writing, and growth strategy.

For [project name], I can take over your social completely for $300 USDT/month. You focus on building, I handle the noise.

Want to see examples of accounts I've managed?`,
  },
  {
    id: 'smm-quick',
    category: 'social',
    label: 'Social Media Management — Quick audit offer',
    badge: 'Easy opener',
    badgeColor: 'blue',
    template: `Hey [name],

I did a quick look at [project name]'s Twitter — the project is interesting but the social presence isn't doing it justice.

I can put together a free 5-point audit showing exactly what's holding your growth back, and what I'd fix. No pitch attached — just useful info.

Want me to send it over?`,
  },
  {
    id: 'smm-launch',
    category: 'social',
    label: 'Social Media Management — Launch sprint',
    badge: 'Pre-TGE',
    badgeColor: 'amber',
    template: `Hey [name],

[project name] is at the exact stage where social media can make or break the launch.

I offer a 2-week launch sprint — daily Twitter content, hype threads, community engagement, and countdown posts timed to your TGE.

Flat rate: $150 USDT for 2 weeks.

Want me to draft a sample week so you can see what it looks like?`,
  },

  // ── COMMUNITY GROWTH ──
  {
    id: 'community-discord',
    category: 'community',
    label: 'Community Growth — Discord setup & management',
    badge: 'Discord focus',
    badgeColor: 'blue',
    template: `Hi [name],

I help Web3 projects build and manage Discord communities — server setup, role structure, engagement campaigns, mod coordination, and growth.

For [project name], I can either set up your Discord from scratch or improve what you already have.

Starting at $100 USDT. I can share a portfolio of servers I've built.

Interested?`,
  },
  {
    id: 'community-growth',
    category: 'community',
    label: 'Community Growth — Full strategy',
    badge: 'Long term',
    badgeColor: 'accent',
    template: `Hey [name],

Community is where Web3 projects live or die — and [project name] has the product to back a strong one.

I'm Ade, a community growth specialist. I build engaged communities across Discord, Telegram, and Twitter — onboarding flows, daily engagement, events, and retention.

I'd love to put together a growth plan tailored to your project stage. 30-min call?`,
  },
  {
    id: 'community-mod',
    category: 'community',
    label: 'Community Growth — Mod trial offer',
    badge: 'Quickest yes',
    badgeColor: 'blue',
    template: `Hey [name],

I'll moderate your Discord or Telegram for free for 24 hours — handle questions, keep things active, enforce rules.

If you like how I run things, we talk about a paid ongoing role ($50–$150 USDT/month depending on size).

Worth trying?`,
  },

  // ── GROWTH MARKETING ──
  {
    id: 'growth-full',
    category: 'growth',
    label: 'Growth Marketing — Full campaign pitch',
    badge: 'Premium offer',
    badgeColor: 'amber',
    template: `Hi [name],

I'm Ade — a Web3 growth marketer. I help projects go from "building in silence" to "everyone's talking about it" through a combination of KOL campaigns, content, community, and airdrop/referral mechanics.

I've been looking at [project name] and I think there's a real opportunity here before your TGE.

I can put together a full pre-launch growth plan — KOL seeding, Twitter growth, community activation. $300–$500 USDT depending on scope.

Can I send you a 1-page outline?`,
  },
  {
    id: 'growth-airdrop',
    category: 'growth',
    label: 'Growth Marketing — Airdrop/Referral campaign',
    badge: 'Viral growth',
    badgeColor: 'accent',
    template: `Hey [name],

One of the fastest ways to grow a Web3 community is a well-structured airdrop or referral campaign — but most projects set it up badly and waste the opportunity.

I can design and manage the full campaign for [project name] — mechanics, KOL amplification, tracking, and follow-up.

Flat fee: $150 USDT. I've done this for [X] projects and it consistently doubles community size within 2 weeks.

Want to see how I'd structure it for your project?`,
  },
  {
    id: 'growth-consulting',
    category: 'growth',
    label: 'Growth Marketing — Strategy consulting',
    badge: 'High trust',
    badgeColor: 'amber',
    template: `Hi [name],

I offer 1-hour Web3 growth strategy sessions — we go through your current marketing, I identify the gaps, and give you a clear 30-day action plan.

$50 USDT for the session. Everything recorded and summarized.

Most founders come out with a clearer roadmap than they've had in months.

Interested?`,
  },

  // ── WORKAROUNDS ──
  {
    id: 'followup',
    category: 'other',
    label: 'Follow-up (send after 4h no reply)',
    badge: 'Send after 4h',
    badgeColor: 'text',
    template: `Just following up — I can have everything ready tonight if you want to move fast.

Happy to adjust scope or price to fit your budget. Just let me know either way.`,
  },
  {
    id: 'discord-workaround',
    category: 'other',
    label: 'Locked DMs — Discord workaround',
    badge: 'DMs locked',
    badgeColor: 'amber',
    template: `Hey [name], found you via [project name]'s Discord.

I'm Ade — Web3 growth marketer. I help projects with KOL management, social media, and community growth.

I can share a free sample of my work for [project name] first so you can judge the quality before committing to anything.

Worth a quick chat?`,
  },
  {
    id: 'quote-tweet',
    category: 'other',
    label: 'Public reply / Quote tweet (DMs locked)',
    badge: 'Public approach',
    badgeColor: 'blue',
    template: `This is exactly the stage where KOL seeding and a tight content strategy can 10x your reach before TGE. @[project] — happy to share what's worked for similar launches if useful. DMs open 👇`,
  },
];

export const PITCH_CATEGORIES = [
  { id: 'all', label: 'All Scripts' },
  { id: 'content', label: 'Content Writing' },
  { id: 'kol', label: 'KOL Management' },
  { id: 'social', label: 'Social Media' },
  { id: 'community', label: 'Community' },
  { id: 'growth', label: 'Growth Marketing' },
  { id: 'other', label: 'Workarounds' },
];

export const HUNT_PLATFORMS = [
  { name: 'X / Twitter', where: 'Use search queries above → filter by Latest', speed: 'Tonight' },
  { name: 'Discord', where: 'Search #partnerships, #collabs, or DM founders directly', speed: 'Tonight' },
  { name: 'LaborX.com', where: 'Post a gig — crypto-native, pays in USDT same day', speed: 'Hours' },
  { name: 'Telegram', where: 'Groups: Web3 Marketing Hub, Crypto Collab Network', speed: 'Tonight' },
  { name: 'X Spaces', where: 'Join live crypto Spaces → DM speakers after it ends', speed: 'Tonight' },
  { name: 'Zealy.io', where: 'Projects post quests and hire community managers here', speed: '24h' },
  { name: 'Galxe.com', where: 'Find active Web3 campaigns — DM project owners', speed: '24h' },
  { name: 'Wellfound', where: 'Web3 startup jobs — filter by Marketing / Community', speed: '24h' },
];
